import React from 'react';
import cx from 'classnames';

import styles from './ProgressBar.module.scss';

interface ProgressBarProps {
  maxValue: number;
  value: number;
  className?: string;
  style?: React.CSSProperties;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ maxValue, value, className, style }) => {
  const progress = (value / maxValue) * 100;

  return (
    <div className={cx(styles.container, className)} style={style}>
      <div className={styles.fill} style={{ width: `${progress}%` }} />
    </div>
  );
};

export default ProgressBar;
